:host {
  font-family: var(--ls-font-family);
  position: relative;
  display: block;
  min-width: 800px;
}

.loading,
.error {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  background-color: white;
}

.disconnected svg {
  display: none;
}

.disconnected::after {
  content: "Disconnected";
  position: absolute;
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  height: 100%;
  font-size: 2.5rem;
  color: #71717a;
  text-transform: uppercase;
  top: 0;
  text-align: center;
  border: 1px solid #71717a;
  background-color: rgba(255, 255, 255, 1);
}

.sensors-labels rect {
    fill: white;
}
  
.sensors-labels text {
    fill: var(--ls-font-primary-color);
    font-size: var(--ls-text-xs);
  }

.swim-lanes text {
    fill: var(--ls-font-primary-color);
  }

